export default __webpack_public_path__ + "static/media/brown-3.2cc032a7.png";